export { default as ArrowDown } from './ArrowDown';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowRight } from './ArrowRight';
export { default as Back } from './Back';
export { default as ChevronDown } from './ChevronDown';
export { default as Close } from './Close';
export { default as Crocusoft } from './Crocusoft';
export { default as Cup } from './Cup';
export { default as Email } from './Email';
export { default as Facebook } from './Facebook';
export { default as Filter } from './Filter';
export { default as InfoIcon } from './Info';
export { default as InfoCircle } from './InfoCircle';
export { default as Instagram } from './Instagram';
export { default as LegalAge } from './LegalAge';
export { default as MenuIcon } from './MenuIcon';
export { default as Minus } from './Minus';
export { default as OneXTwo } from './OneXTwo';
export { default as Phone } from './Phone';
export { default as Plus } from './Plus';
export { default as Prize } from './Prize';
export { default as SackMoney } from './SackMoney';
export { default as Stats } from './Stats';
export { default as Three } from './Three';
export { default as Tiktok } from './Tiktok';
export { default as Topaz } from './Topaz';
export { default as Transparency } from './Transparency';
export { default as UniqueSportsBetting } from './UniqueSportsBetting';
export { default as Verify } from './Verify';
export { default as Whatsapp } from './Whatsapp';
